export default __webpack_public_path__ + "static/media/Accounts.3b468b46.png";